module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "down-payment"
  }, [(_vm.product.strikePriceTag) ? _c('div', {
    staticClass: "downpay-strike"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.ensureImage(_vm.product.strikePriceTag.bgImage)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "discount-price-box",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_c('div', {
    staticClass: "discount-price"
  }, [_c('div', {
    staticClass: "price-item"
  }, [_c('div', {
    staticClass: "price-label",
    style: ({
      'color': _vm.product.strikePriceTag.titleColor
    })
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.title1))]), _vm._v(" "), _c('div', {
    staticClass: "price-box",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_vm._v("¥ "), _c('span', {
    staticClass: "int"
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.originalPrice ? _vm.product.strikePriceTag.originalPrice.toFixed() : 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "price-item min"
  }, [_c('div', {
    staticClass: "price-label math"
  }), _vm._v(" "), _c('div', {
    staticClass: "price-box math",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_vm._v("-")])]), _vm._v(" "), _c('div', {
    staticClass: "price-item"
  }, [_c('div', {
    staticClass: "price-label",
    style: ({
      'color': _vm.product.strikePriceTag.titleColor
    })
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.title2))]), _vm._v(" "), _c('div', {
    staticClass: "price-box",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_vm._v("¥ "), _c('span', {
    staticClass: "int"
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.couponPrice ? _vm.product.strikePriceTag.couponPrice.toFixed() : 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "price-item min"
  }, [_c('div', {
    staticClass: "price-label math"
  }), _vm._v(" "), _c('div', {
    staticClass: "price-box math",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_vm._v("=")])]), _vm._v(" "), _c('div', {
    staticClass: "price-item last"
  }, [_c('div', {
    staticClass: "price-label",
    style: ({
      'color': _vm.product.strikePriceTag.titleColor
    })
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.title3))]), _vm._v(" "), _c('div', {
    staticClass: "price-box",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_vm._v("¥ "), _c('span', {
    staticClass: "int"
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.strikePrice ? _vm.product.strikePriceTag.strikePrice.toFixed() : 0))]), (_vm.product.variant.spvs.length > 1) ? _c('span', [_vm._v("起")]) : _vm._e()])])])])], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82480f52"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/down-payment.vue
// module id = 1015
// module chunks = 2